import React from 'react'
import styled from 'styled-components'
import Toggle from 'components/Toggle'

export default ({ equipment, selected, onToggle }) => (
  <EquipmentWrapper>
    <Name>{equipment.name}</Name>
    <Toggle selected={selected} onClick={() => onToggle()} />
  </EquipmentWrapper>
)

const EquipmentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #efefef;
  padding: 10px;
`

const Name = styled.span`
  color: #010101;
  font-family: Nunito;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
`



// WEBPACK FOOTER //
// ./src/components/EquipmentToggler/index.js